import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-brand-darkbrown text-brand-cream">
      {/* Ornamental Top Border */}
      <div className="h-px bg-gradient-to-r from-transparent via-brand-gold to-transparent" />

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/a84fce21c15147349888dd3eeb9b8000/937748a816123b3aa330f9d4b73acce1.png"
              alt="M. Hayat & Co."
              className="h-14 w-auto object-contain mb-5 brightness-0 invert opacity-90"
            />
            <p className="text-sm text-brand-cream/60 leading-relaxed font-sans mb-6">
              Crafting timeless furniture since 1870. Six generations of heritage craftsmanship, bringing legacy and
              luxury into every home.
            </p>
            <div className="flex items-center gap-4">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/m.hayatandco/" },
                { icon: "ri-facebook-circle-line", href: "#" },
                { icon: "ri-whatsapp-line", href: "#" },
                { icon: "ri-pinterest-line", href: "#" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center border border-brand-cream/20 rounded-full text-brand-cream/60 hover:border-brand-gold hover:text-brand-gold transition-all duration-300 cursor-pointer"
                  rel="nofollow"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-brand-gold text-sm tracking-widest uppercase mb-6">
              <a href="#explore">Explore</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Collections", path: "/collections" },
                { label: "Gallery", path: "/gallery" },
                { label: "About", path: "/about" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-brand-cream/60 hover:text-brand-gold transition-colors duration-200 font-sans"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Collections */}
          <div>
            <h4 className="font-serif text-brand-gold text-sm tracking-widest uppercase mb-6">
              <a href="#collections">Collections</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Living", path: "/collections?category=living" },
                { label: "Bedroom", path: "/collections?category=bedroom" },
                { label: "Dining", path: "/collections?category=dining" },
                { label: "Custom Orders", path: "/collections?category=custom-orders" },
                { label: "Signature Pieces", path: "/collections?category=signature-pieces" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-brand-cream/60 hover:text-brand-gold transition-colors duration-200 font-sans"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-brand-gold text-sm tracking-widest uppercase mb-6">
              <a href="#reach-us">Reach Us</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-brand-gold text-sm" />
                </div>
                <span className="text-sm text-brand-cream/70 font-sans">0333 5281400</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-whatsapp-line text-brand-gold text-sm" />
                </div>
                <a
                  href="https://wa.me/923335281400"
                  className="text-sm text-brand-cream/70 hover:text-brand-gold transition-colors duration-200 font-sans cursor-pointer"
                  rel="nofollow"
                >
                  WhatsApp Us
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-brand-gold text-sm" />
                </div>
                <span className="text-sm text-brand-cream/70 font-sans">info@mhayatco.com</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-brand-gold text-sm" />
                </div>
                <span className="text-sm text-brand-cream/70 font-sans leading-relaxed">
                  M.Hayat &amp; Co. Near Chaye Khana,
                  <br />
                  Bahria Phase 7, Rawalpindi
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-brand-cream/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-brand-cream/40 font-sans">
            &copy; 2026 M. Hayat &amp; Co. All rights reserved. Est. 1870.
          </p>
          <div className="flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-brand-gold" />
            <span className="text-xs text-brand-cream/40 font-sans italic font-serif">
              Crafting Timeless Furniture Since 1870
            </span>
            <span className="w-1 h-1 rounded-full bg-brand-gold" />
          </div>
        </div>
      </div>
    </footer>
  );
}
